import { createFileRoute } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { FileText } from "lucide-react";

export const Route = createFileRoute("/admin/invoices")({
  component: () => (
    <StubAdminPage
      icon={FileText}
      title="Invoices"
      subtitle="Billing and payment history"
    />
  ),
});
